import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { H1, Body1, Contact, Button, Dialog } from '../../../cdl-react-components/components'
import HubSpotForm from '../../../Utilities/HubspotForm'

class RegionalMapShapefileContact extends Component {
    state = { open: false }

    handleOpen = () => this.setState({ open: true })
    handleClose = () => this.setState({ open: false })

    render() {
        const { map } = this.props

        return map && map.has_purchasable_shapefile ? (
            <Fragment>
                <div className="regional-map__shapefile-contact">
                    <Button 
                        raised
                        secondary
                        onClick={this.handleOpen}>Purchase Shapefiles</Button>
                </div>
                <Dialog                    
                    open={this.state.open}
                    onClose={this.handleClose}>
                    <HubSpotForm
                        style={{ minWidth: "720px" }}
                        portalId="24157678"
                        formId="89f2bc93-c8c2-4c5c-a7d0-2cdcd610ead3"
                        onFormSubmitted={this.handleClose} />
                </Dialog>
            </Fragment>
        ) : null
    }
}

RegionalMapShapefileContact.propTypes = {
    map: PropTypes.object
}

export default RegionalMapShapefileContact